import { dirname, join, resolve } from "path";
import { parseSync } from "oxc-parser";
import MagicString from "magic-string";
import { resolvePath } from "@vxrn/resolve";
import FSExtra from "fs-extra";
import fs from "fs-extra";
import { serverlessVercelNodeJsConfig } from "../config/vc-config-base";
import { serverlessVercelPackageJson } from "../config/vc-package-base";
import { getPathFromRoute } from "../getPathFromRoute";
async function createApiServerlessFunction(route, code, oneOptionsRoot, postBuildLogs) {
  var outDir = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "dist";
  try {
    var path = getPathFromRoute(route, {
      includeIndex: true
    });
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] pageName: ${path}`);
    var funcFolder = join(oneOptionsRoot, `.vercel/output/functions/${path}.func`);
    await fs.ensureDir(funcFolder);
    if (code.includes("react")) {
      postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] detected react in depenency tree for ${path}`);
      var reactPath = dirname(resolvePath("react/package.json", oneOptionsRoot));
      await fs.copy(resolve(reactPath), resolve(join(funcFolder, "node_modules", "react")));
    }
    var distAssetsFolder = resolve(join(funcFolder, "assets"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] copy shared assets to ${distAssetsFolder}`);
    var sourceAssetsFolder = resolve(join(oneOptionsRoot, outDir, "api", "assets"));
    if (await FSExtra.pathExists(sourceAssetsFolder)) {
      await fs.copy(sourceAssetsFolder, distAssetsFolder);
    }
    await fs.ensureDir(resolve(join(funcFolder, "entrypoint")));
    var entrypointFilePath = resolve(join(funcFolder, "entrypoint", "index.js"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing entrypoint to ${entrypointFilePath}`);
    await fs.writeFile(entrypointFilePath, wrapHandlerFunctions(code));
    var packageJsonFilePath = resolve(join(funcFolder, "package.json"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing package.json to ${packageJsonFilePath}`);
    await fs.writeJSON(packageJsonFilePath, serverlessVercelPackageJson);
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing .vc-config.json to ${join(funcFolder, ".vc-config.json")}`);
    return fs.writeJson(join(funcFolder, ".vc-config.json"), {
      ...serverlessVercelNodeJsConfig,
      handler: "entrypoint/index.js"
    });
  } catch (e) {
    console.error(`[one.build][vercel.createSsrServerlessFunction] failed to generate func for ${route.file}`, e);
  }
}
function wrapHandlerFunctions(code) {
  var parsed;
  try {
    parsed = parseSync("api.js", code);
  } catch (unused) {
    return code;
  }
  if (!(parsed === null || parsed === void 0 ? void 0 : parsed.program)) return code;
  var functionNamesToHandle = /* @__PURE__ */ new Set([
    "GET",
    "POST",
    "PUT",
    "PATCH",
    "DELETE",
    "HEAD",
    "OPTIONS"
  ]);
  var ms = new MagicString(code);
  var wrappersToAppend = [];
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = (parsed.program.body || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      var _item_declaration, _fnDecl_id;
      var fnDecl = null;
      var isExported = false;
      var exportNode = null;
      if (item.type === "ExportNamedDeclaration" && ((_item_declaration = item.declaration) === null || _item_declaration === void 0 ? void 0 : _item_declaration.type) === "FunctionDeclaration") {
        fnDecl = item.declaration;
        isExported = true;
        exportNode = item;
      } else if (item.type === "FunctionDeclaration") {
        fnDecl = item;
        isExported = false;
      }
      if (!fnDecl || !((_fnDecl_id = fnDecl.id) === null || _fnDecl_id === void 0 ? void 0 : _fnDecl_id.name) || !functionNamesToHandle.has(fnDecl.id.name)) {
        continue;
      }
      var name = fnDecl.id.name;
      var originalName = `orig_${name}`;
      if (isExported) {
        ms.remove(exportNode.start, fnDecl.start);
      }
      ms.overwrite(fnDecl.id.start, fnDecl.id.end, originalName);
      var exportPrefix = isExported ? "export " : "";
      wrappersToAppend.push(`
${exportPrefix}function ${name}(request) {
  const url = new URL(request.url);
  const params = Object.fromEntries(url.searchParams.entries());
  return ${originalName}(request, { params });
}`);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  if (wrappersToAppend.length > 0) {
    ms.append(wrappersToAppend.join("\n"));
    return ms.toString();
  }
  return code;
}
export {
  createApiServerlessFunction
};
//# sourceMappingURL=createApiServerlessFunction.js.map
